/**
 * frontend/src/pages/valuation/_typedFinancialsText.ts
 *
 * VAL-PATH-TYPED-FINANCIALS (P2c) — every client-visible string for typed
 * figures, in one place. ROUTE_UPLOAD / ROUTE_TYPE are owner-approved verbatim
 * (OWNER_APPROVALS.log 10-22 10:58).
 */
/** Owner-approved (OWNER_APPROVALS.log 2026-10-22 20:37 CT, P2C TEXT) — every key below. */
export const CLIENT_TEXT = {
  ROUTE_UPLOAD: 'Upload your files',
  ROUTE_TYPE: 'Enter your figures yourself',
  TYPE_INTRO: 'Type each year’s figures as they appear in your books. Revenue, cost of goods sold and operating expenses are needed for every year, and at least two years. If a figure is zero, enter 0.',
  ADD_YEAR: 'Add a year',
  REMOVE_YEAR: (y: number | string) => `Remove FY${y}`,
  YEAR_LABEL: 'Fiscal year',
  SAVE: 'Save figures',
  SAVED: 'Figures saved.',
  YEAR_MISSING: 'Enter the fiscal year for every year you add.',
  YEAR_FROM_FILES: (y: number) => `FY${y} already has figures from your files.`,
  YEAR_TWICE: (y: number) => `FY${y} is entered twice.`,
  SOURCES_HEADING: 'Where these figures came from',
  SOURCES_NO_FILES: 'No files for this year.',
  SOURCES_TYPED_VALUE: (v: string) => `${v} entered by the owner`,
  SOURCES_FILE_VALUE: (v: string, file: string) => `${v} in ${file}`,
  REVIEW_HEADING: 'Figures entered by the owner',
  REVIEW_INTRO: 'The owner typed these years. They have not been checked against documents.',
  REVIEW_REASON_LABEL: 'Reason for accepting these figures',
  REVIEW_ACCEPT: 'Accept these figures',
  REVIEW_NEED_REASON: 'Enter a reason first.',
  REVIEW_ACCEPTED: (by: string, at: string, reason: string) => `Accepted by ${by}, ${at}: ${reason}`,
  REVIEW_STALE: 'The figures changed after they were accepted. Accept them again.',
} as const
